import { createContext } from 'react';
import type { RefObject } from 'react';

export interface InteractionContextValue {
  readonly boardRef: RefObject<HTMLDivElement>;
  readonly trashRef: RefObject<HTMLDivElement>;
}

export const InteractionContext = createContext<InteractionContextValue | null>(null);
